import { CalendarAgendaPaneHandle } from '../components/CalendarAgendaPane';

let agendaPaneRef: () => CalendarAgendaPaneHandle;
/**
 * This initializes the focus elements used to:
 * 1. focusing on the agenda after clicking the overflow indicator on the month surface
 *
 * @param getCalendarAgendaPaneHandleComponent
 */
export function registerFocusElements(
    getCalendarAgendaPaneHandleComponent: () => CalendarAgendaPaneHandle
) {
    agendaPaneRef = getCalendarAgendaPaneHandleComponent;
}

export function getCalendarAgendaPaneComponent() {
    if (!agendaPaneRef) {
        throw new Error(
            'Need to call registerFocusElements before invoking getCalendarAgendaComponent'
        );
    }
    return agendaPaneRef();
}
